import Loading from "../../components/Common/Loading";
import UserSocialInfo from "./userSocialInfo";
import {useEffect, useState} from "react";
import {useGetUserInfoV1TOHQuery} from "../../core/api/toh-analytical-data-api";
import {useGetUserInfoV1DSQuery} from "../../core/api/ds-analytical-data-api";


const UserSocialInfoDS = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoV1DSQuery(props.deviceId)
    const [infoData, setInfoData] = useState("");

    useEffect(() => {
        setInfoData(data)

    }, [data])

    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {infoData && <UserSocialInfo
                data={infoData}

            />
            }
        </Loading>
    )
}

export default UserSocialInfoDS